interface Props {
  /** Which calendar turned the day off: the whole planbook, or just this course. */
  danglingLessonType: "course" | "planbook"
}

/**
 * Says why a lesson is showing on a day with no class — the day went off after the lesson was
 * written, so the lesson is stranded — and how to clear it. Without this the slot would look
 * like a bug: a class on a day the teacher has already turned off.
 */
export default function DanglingLessonNotice({ danglingLessonType }: Props) {
  return (
    <div data-test="dangling lesson notice" className="pb-2">
      <div className="pb-1.5 text-lg leading-none font-bold">
        {danglingLessonType === "planbook"
          ? "Today is off, but there’s still a lesson here."
          : "You’ve turned this class off, but there’s still a lesson here."}
      </div>
      <div className="text-[0.84375rem] leading-none text-gray-700">
        To hide this class, use the Lesson Menu to bump or erase this lesson.
      </div>
    </div>
  )
}
